import React from "react";
import {
  Box,
  TextField,
  FormControl,
  InputAdornment,
  InputLabel,
  Input,
  IconButton,
  Button,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  Alert,
  Tabs,
  Tab,
  Stack,
  Checkbox,
} from "@mui/material";
import {
  AccountCircleOutlined,
  Visibility,
  VisibilityOff,
  LockOutlined,
  Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set, range } from "lodash";
import { Grid } from "../../../../components/table";
import { CONFIG } from "../../../../../config";
import axios from "axios";
import { ToolBar } from "../../../../components/toolbar";
import { Modal } from "../../../../components/modal";
import { FormA, SelectA } from "../../../../components/form";
import moment from "moment";
import { getFormState } from "../../../../../helpers/form";
import dayjs from "dayjs";
import BoltIcon from "@mui/icons-material/Bolt";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import { ListItem, ListItemButton, ListItemText } from "@mui/material";

import IosShareIcon from "@mui/icons-material/IosShare";
import PropTypes from "prop-types";
import { filterColumns } from "../../column-manager";
import useDebounce from "../../../../../hooks/useDebounce";
import SelectedCasesList from "../../master-database/components/selected-cases-list";
const durationPulgin = require("dayjs/plugin/duration");
dayjs.extend(durationPulgin);

const API_HOST = CONFIG.modules["accounts"].host;
const API_HOST_CRM = CONFIG.modules["crm"].host;

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const getTotalWeekOfCurrentMonth = () => {
  return Math.ceil(dayjs().daysInMonth() / 7);
};

const getWeekOfMonth = () => {
  return dayjs.duration().weeks();
};

export const PreviouslyUnattempted = (props) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          {/* <Tab label="NEW DATA" {...a11yProps(0)} /> */}
          <Tab label="FOLLOW-UPS" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <List
          heading={""}
          sx={{ fontSize: ".1em" }}
          type={"newdata"}
          socket={props.socket}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <List heading={""} type={"follow-up"} socket={props.socket} />
      </CustomTabPanel>
      {/* <CustomTabPanel value={value} index={2}>
        <List heading={""} type={"transferred"} socket={props.socket} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <List heading={""} type={"on-call"} socket={props.socket} />
      </CustomTabPanel> */}
    </Box>
  );
};

export const List = ({ heading, type, socket }) => {
  const {
    roles,
    user,
    users,
    Designations,
    Departments,
    Languages,
    Districts,
    map,
    UnassignReasons,
  } = useSelector((state) => state.user || {});
  const userStore = useSelector((state) => state.user || {});
  console.log("length", dayjs.duration().asWeeks());

  const [active, setActive] = useState("Employees");
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState("new");
  const [saved, setSaved] = useState(null);
  const [index, setIndex] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [assigning, setAssigning] = useState(false);
  const [assignCompleted, setAssignCompleted] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [unassignReason, setUnassignReason] = useState(null);

  // temp alert logic
  // const [first, set]

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [count, setCount] = useState(0);
  const [selectedSankalpData, setSelectedSankalpData] = useState(null);

  const oneDayBefore = dayjs().subtract(1, "day");
  let filterObject = {
    from: null, // dayjs("01-01-2023"),
    to: null, //dayjs(),
    cfrom: null,
    cto: null,
    ...(type === "newdata"
      ? {
          dataType: ["newdata"],
          status: ["Pending"],
          to: oneDayBefore,
        }
      : null),
    ...(type === "follow-up"
      ? {
          dataType: ["follow-up"],
          status: ["Pending"],
          to: oneDayBefore,
        }
      : null),
  };

  const [filter, setFilter] = useState(filterObject);

  const [openUnassign, setOpenUnassign] = useState(false);
  const [unAssigning, setUnAssigning] = useState(false);
  const [unAssignCompleted, setUnassignCompleted] = useState(null);

  // states for selecting and assignning
  const [staticSelectedRows, setStaticSelectedRows] = useState(new Map());
  const [activeSelectedAssign, setActiveSelectedAssign] = useState(null);
  const [openAssignSelected, setOpenAssignSelected] = useState(false);
  const [selectedAgents, setSelectedAgents] = useState({});
  const [assignSelectedCompleted, setAssignSelectedCompleted] = useState(false);
  const [assigningSelected, setAssigningSelected] = useState(false);

  const [editOpen, setEditOpen] = useState(false);

  useEffect(() => {
    console.log(filter);
  }, [filter]);

  useEffect(() => {
    if (socket) {
      socket.on("case-update", (data) => {
        // getList(true);
        // debouncedGetList(true, filter);
      });
    }
    return () => {
      if (socket) {
        socket.removeAllListeners();
      }
    };
  }, [socket]);

  const getList = (keep) => {
    // if (!keep) {
    //   setData([]);
    // }

    // if (keep) {
    //   setFilter({ ...filter });
    // }

    axios
      .get(
        API_HOST_CRM +
          `/cases?limit=${rowsPerPage}` +
          // `&page=${page}&type=test` +
          //   `&page=${page}&type=${type}` +
          `${
            filter.from
              ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
              : ""
          }` +
          `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}` +
          `${
            filter.status
              ? `&status=${encodeURIComponent(JSON.stringify(filter.status))}`
              : ""
          }` +
          `${
            filter.district
              ? `&district=${encodeURIComponent(
                  JSON.stringify(filter.district)
                )}`
              : ""
          }` +
          `${
            filter.dataType
              ? `&dataType=${encodeURIComponent(
                  JSON.stringify(filter.dataType)
                )}`
              : ""
          }` +
          // `${filter.dataType ? `&dataType=${filter.dataType}` : ""}` +
          `${filter.motherID ? `&motherId=${filter.motherID}` : ""}` +
          `${filter.motherName ? `&motherName=${filter.motherName}` : ""}` +
          `${filter.contact ? `&contact=${filter.contact}` : ""}` +
          // `${filter.motherStatus ? `&motherStatus=${filter.motherStatus}` : ""}` +
          `${
            filter.motherStatus
              ? `&motherStatus=${encodeURIComponent(
                  JSON.stringify(filter.motherStatus)
                )}`
              : ""
          }` +
          // `${filter.telecaller ? `&telecaller=${filter.telecaller}` : ""}` +
          `${
            filter.telecaller
              ? `&telecaller=${encodeURIComponent(
                  JSON.stringify(filter.telecaller)
                )}`
              : ""
          }` +
          `${
            filter.allocatedToUser
              ? `&allocatedToUser=${encodeURIComponent(
                  JSON.stringify(filter.allocatedToUser)
                )}`
              : ""
          }` +
          `${
            filter.dateReceived ? `&dateReceived=${filter.dateReceived}` : ""
          }` +
          `${filter.nextCallDue ? `&nextCallDue=${filter.nextCallDue}` : ""}` +
          `${filter.callDate ? `&callDate=${filter.callDate}` : ""}` +
          `${
            filter.lastCallDate ? `&lastCallDate=${filter.lastCallDate}` : ""
          }` +
          `${filter.attempt ? `&attempt=${filter.attempt}` : ""}` +
          `${
            filter.transferredFrom
              ? `&transferredFrom=${filter.transferredFrom}`
              : ""
          }` +
          `${
            filter.transferStatus
              ? `&transferStatus=${filter.transferStatus}`
              : ""
          }` +
          `${
            filter.cfrom
              ? `&cfrom=${dayjs(filter.cfrom).format("YYYY-MM-DD")}`
              : ""
          }` +
          `${
            filter.cto ? `&cto=${dayjs(filter.cto).format("YYYY-MM-DD")}` : ""
          }` +
          `${filter.week ? `&week=${filter.week}` : ""}` +
          // `${filter.priority ? `&priority=${filter.priority}` : ""}` +
          `${
            filter.priority
              ? `&priority=${encodeURIComponent(
                  JSON.stringify(filter.priority)
                )}`
              : ""
          }`
      )
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setData(resp.data.cases);
          setCount(resp.data.count);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const [debouncedGetList, isLoading] = useDebounce(getList, 300);

  useEffect(() => {
    debouncedGetList();
    // getList();
  }, [page, rowsPerPage, filter]);

  useEffect(() => {
    getList();
  }, []);

  //   useEffect(()=>{
  // if(data.length== 0){
  //   alert("no data bro")
  // }
  //   },[data])

  const exportMotherReport = (data) => {
    axios
      .get(
        API_HOST_CRM +
          `/export-motherData?id=${data.motherID}&from=${encodeURIComponent(
            dayjs(filter.from).format("YYYY-MM-DD")
          )}&to=${encodeURIComponent(dayjs(filter.to).format("YYYY-MM-DD"))}
				
				`,
        {
          responseType: "arraybuffer",
        }
      )
      .then((resp) => {
        if (resp) {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Mother_Report_${data.motherID}+${data.name}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          console.log(resp);
          link.remove();
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <>
      <ToolBar
        name={heading}
        height={"3em"}
        buttons={
          type == "in-queue"
            ? [
                {
                  name: unAssignCompleted
                    ? "UnAssign Completed"
                    : unAssigning
                    ? `Unassigning.....`
                    : `Unassign Selected (${selectedRows.length})`, //assignCompleted
                  // ? "Assign Completed"
                  // : assigning
                  // ? "Assigning....."
                  // : "Assign Auto",
                  // type: 'chip',
                  disable: selectedRows.length == 0,
                  icon: () => <BoltIcon sx={{ fontSize: "1.2em" }} />,
                  onClick: () => {
                    if (!unAssigning && !unAssignCompleted) {
                      setOpenUnassign(true);
                      setUnassignReason(null);
                    }
                  },
                },
              ]
            : [
                {
                  name: assignCompleted
                    ? "Assign Completed"
                    : assigning
                    ? "Assigning....."
                    : "Assign Auto",
                  // type: 'chip',
                  icon: () => <BoltIcon sx={{ fontSize: "1.2em" }} />,
                  onClick: () => {
                    if (!assigning && !assignCompleted) {
                      setAssigning(true);
                      axios
                        .get(API_HOST_CRM + "/allocate-auto")
                        .then((resp) => {
                          if (resp.data && resp.data.success) {
                            setAssigning(false);
                            setAssignCompleted(true);
                            setTimeout(() => {
                              setAssignCompleted(false);
                            }, 2000);
                          }
                          setAssigning(false);
                          // new code
                          setStaticSelectedRows(new Map());
                        })
                        .catch((e) => {
                          console.log(e);
                          setAssigning(false);
                        });
                    }
                  },
                },
                // {
                //   name: `Assign (${selectedRows.length}) Selected`,
                //   disable: selectedRows.length == 0,
                //   // type: 'chip',
                //   icon: () => <ArrowOutwardIcon sx={{ fontSize: "1.2em" }} />,
                //   onClick: () => {
                //     if (true) {
                //       setAssignSelectedCompleted(false);
                //       setOpenAssignSelected(true);
                //       setActiveSelectedAssign(null);
                //     }
                //   },
                // },
                {
                  name: `Assign (${staticSelectedRows.size}) Selected`,
                  disable: staticSelectedRows.size == 0,
                  // type: 'chip',
                  icon: () => <ArrowOutwardIcon sx={{ fontSize: "1.2em" }} />,
                  onClick: () => {
                    if (true) {
                      setAssignSelectedCompleted(false);
                      setOpenAssignSelected(true);
                      setActiveSelectedAssign(null);
                    }
                  },
                },
              ]
        }
        onClearFilter={() => {
          setFilter({
            from: null,
            to: null,
            cfrom: null,
            cto: null,
            firstReceived: null,
            motherName: "",
            motherID: "",
            contact: "",
            status: null,
            motherStatus: null,
            telecaller: null,
            district: null,
          });
        }}
        filters={[
          {
            field: {
              name: "from",
              type: "date",
              label: "Assign From",
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          {
            field: {
              name: "to",
              type: "date",
              label: "Assign To",
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
        ]}
      />
      <Box sx={{ mt: 2 }}>
        <Grid
          data={data}
          onSelectChange={(selected) => {
            console.log(selected);
            setSelectedRows(selected);
          }}
          setStaticSelectedRows={setStaticSelectedRows}
          staticSelectedRows={staticSelectedRows}
          // filter={filter}
          columns={[
            ...filterColumns(
              [
                {
                  id: "motherID",
                  showFilter: true,
                },
                {
                  id: "name",
                  showFilter: true,
                },
                {
                  id: "contact",
                  showFilter: true,
                },
                {
                  id: "districtName",
                  showFilter: true,
                  type: "select",
                },
                {
                  id: "dataType",
                  showFilter: false,
                  type: "select",
                },
                {
                  id: "dateReceived",
                  showFilter: true,
                },
                {
                  id: "lastCallDate",
                  showFilter: true,
                },
                {
                  id: "callDate",
                  showFilter: true,
                },
                {
                  id: "priority",
                  showFilter: true,
                  type: "select",
                },
                {
                  id: "allocatedToUser",
                  // showFilter: true,
                  isSelect: true,
                },
                {
                  id: "motherStatus",
                  showFilter: true,
                  type: "select",
                },
                {
                  id: "nextCallDue",
                  showFilter: true,
                },
                // ...[
                //   !["in-queue", "on-call"].includes(type)
                //     ? {
                //         id: "status",
                //         showFilter: false,
                //         type: "select",
                //       }
                //     : {},
                // ],
                {
                  id: "attempt",
                  showFilter: true,
                  minWidth: 150,
                },
                {
                  id: "transferredFrom",
                  showFilter: true,
                  type: "select",
                  minWidth: 200,
                },
                {
                  id: "transferStatus",
                  showFilter: true,
                  minWidth: 150,
                },
              ],
              filter,
              setFilter,
              { Districts, users, map }
            ),
          ]}
          pagination={{
            rowsPerPageOptions: [10, 25, 50],
            page,
            rowsPerPage,
            onPageChange: (event, newPage) => {
              setPage(newPage);
            },
            onRowsPerPageChange: (event) => {
              setRowsPerPage(+event.target.value);
              setPage(0);
            },
            count,
          }}
        ></Grid>
      </Box>

      {/* assign auto / manually */}

      <Modal
        open={open}
        handleClose={() => {
          setOpen(false);
        }}
        head={`Sankalp Data`}
        buttons={[
          {
            name: "Cancel",
            onClick: () => {
              setOpen(false);
            },
          },
        ]}
      >
        {selectedSankalpData &&
          selectedSankalpData.sankalpData &&
          Object.keys(selectedSankalpData.sankalpData).map((s, i) => {
            const map = {
              pregStatus: "Pregnancy Status",
              advice: "Advice",
              pregnancyNumber: "Pregnancy Number",
              pretermDelivery: "Pre-term Delivery",
              nearResidance: "Near By Residence",
              trimester: "Trimester",
            };
            return (
              <Box key={i} sx={{ display: "flex", mt: 1 }}>
                <Typography variant="p">{map[s] || s}: </Typography>&nbsp;
                <Typography
                  variant="p"
                  sx={{ color: "grey", fontSize: ".9em" }}
                >
                  {selectedSankalpData.sankalpData[s]}
                </Typography>
              </Box>
            );
          })}
      </Modal>

      <Modal
        open={openAssignSelected}
        handleClose={() => {
          setOpenAssignSelected(false);
        }}
        // head={`Assign selected (${selectedRows.length}) cases`}
        head={`Assign selected (${staticSelectedRows.size}) cases`}
        buttons={[
          {
            name: "Close",
            onClick: () => {
              setOpenAssignSelected(false);
            },
          },
        ]}
        styleA={"md"}
      >
        <Box>
          {!activeSelectedAssign && (
            <Stack direction={"column"} spacing={2}>
              <Stack direction={"row"} spacing={2}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setActiveSelectedAssign("agent-auto");
                    setAssigningSelected(true);

                    axios
                      .post(API_HOST_CRM + "/allocate-auto-selected", {
                        // cases: selectedRows.map((n) => n._id),
                        cases: Array.from(staticSelectedRows.values()).map(
                          (n) => n._id
                        ),
                      })
                      .then((resp) => {
                        if (resp.data && resp.data.success) {
                          setAssigningSelected(false);
                          setAssignSelectedCompleted(true);
                          setStaticSelectedRows(new Map());
                        } else {
                          setAssigningSelected(false);
                        }
                      })
                      .catch((e) => {
                        setAssigningSelected(false);
                        console.log(e);
                      });
                  }}
                  size="small"
                  sx={{ width: "max-content" }}
                >
                  <BoltIcon sx={{ fontSize: "1.2em" }} /> &nbsp;Assign auto
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setActiveSelectedAssign("selected-agent");
                    setAssignSelectedCompleted(false);
                  }}
                  size="small"
                  sx={{ width: "max-content", ml: 1 }}
                >
                  <ArrowOutwardIcon sx={{ fontSize: "1.2em" }} /> &nbsp;Assign
                  to selected agent
                </Button>
              </Stack>

              <SelectedCasesList
                staticSelectedRows={staticSelectedRows}
                setStaticSelectedRows={setStaticSelectedRows}
              />
            </Stack>
          )}
          {activeSelectedAssign == "agent-auto" && (
            <Box>
              <Typography>
                {assignSelectedCompleted
                  ? "Assign Completed"
                  : assigningSelected
                  ? "Assigning....."
                  : ""}
              </Typography>
            </Box>
          )}
          {activeSelectedAssign == "selected-agent" && (
            <Box
              sx={{ ...(assigningSelected ? { pointerEvents: "none" } : {}) }}
            >
              <Box sx={{ mb: 1 }}>
                <Box
                  sx={{ cursor: "pointer", width: "fit-content" }}
                  onClick={() => {
                    setActiveSelectedAssign(null);
                  }}
                >
                  <ArrowBackIcon sx={{ fontSize: "1.2em" }} /> &nbsp;Back
                </Box>
              </Box>
              <Box sx={{ pl: 2 }}>
                <Box
                  sx={{
                    mb: 2,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography sx={{ fontWeight: "bold" }}>
                    Select Agents
                  </Typography>
                  <Box sx={{ display: "flex" }}>
                    {`selected (${Object.values(selectedAgents).length})`}
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setAssigningSelected(true);

                        axios
                          .post(API_HOST_CRM + "/allocate-selected-selected", {
                            // cases: selectedRows.map((n) => n._id),
                            cases: Array.from(staticSelectedRows.values()).map(
                              (n) => n._id
                            ),
                            agents: Object.values(selectedAgents).map(
                              (a) => a._id
                            ),
                          })
                          .then((resp) => {
                            if (resp.data && resp.data.success) {
                              setAssigningSelected(false);
                              setAssignSelectedCompleted(true);
                              setStaticSelectedRows(new Map());
                            } else {
                              setAssigningSelected(false);
                            }
                          })
                          .catch((e) => {
                            setAssigningSelected(false);
                            console.log(e);
                          });
                      }}
                      size="small"
                      sx={{ width: "max-content", ml: 1 }}
                    >
                      <DoubleArrowIcon sx={{ fontSize: "1.2em" }} /> &nbsp;
                      {assignSelectedCompleted
                        ? "Assign Completed"
                        : assigningSelected
                        ? "Assigning....."
                        : "Assign"}
                    </Button>
                  </Box>
                </Box>
                {Array.isArray(users) &&
                  users
                    .filter((u) =>
                      (u.roles || []).includes(process.env.REACT_APP_TELECALLER)
                    )
                    .map((u, i) => {
                      return (
                        <ListItem key={i} disablePadding>
                          <ListItemButton>
                            <Checkbox
                              checked={!!selectedAgents[u._id]}
                              onChange={(e) => {
                                let obj = { ...selectedAgents };
                                if (e.target.checked) {
                                  obj[u._id] = u;
                                } else {
                                  if (obj[u._id]) {
                                    delete obj[u._id];
                                  }
                                }
                                setSelectedAgents(obj);
                              }}
                            />{" "}
                            <ListItemText
                              primaryTypographyProps={{ fontSize: ".8em" }}
                              primary={`${u.name}`}
                              onClick={() => {
                                // addUserToShift(u._id);
                              }}
                            />
                          </ListItemButton>
                        </ListItem>
                      );
                    })}
              </Box>
            </Box>
          )}
        </Box>
      </Modal>

      <Modal
        open={open}
        handleClose={() => {
          setOpen(false);
        }}
        head={`Sankalp Data`}
        buttons={[
          {
            name: "Cancel",
            onClick: () => {
              setOpen(false);
            },
          },
        ]}
      >
        {selectedSankalpData &&
          selectedSankalpData.sankalpData &&
          Object.keys(selectedSankalpData.sankalpData).map((s, i) => {
            const map = {
              pregStatus: "Pregnancy Status",
              advice: "Advice",
              pregnancyNumber: "Pregnancy Number",
              pretermDelivery: "Pre-term Delivery",
              nearResidance: "Near By Residence",
              trimester: "Trimester",
            };
            return (
              <Box key={i} sx={{ display: "flex", mt: 1 }}>
                <Typography variant="p">{map[s] || s}: </Typography>&nbsp;
                <Typography
                  variant="p"
                  sx={{ color: "grey", fontSize: ".9em" }}
                >
                  {selectedSankalpData.sankalpData[s]}
                </Typography>
              </Box>
            );
          })}
      </Modal>

      <Modal
        open={openUnassign}
        handleClose={() => {
          // setOpenUnassign(false);
        }}
        head={`Unassign Cases`}
        buttons={[
          ...(unAssigning
            ? []
            : [
                {
                  name: "Unassign",
                  onClick: () => {
                    setUnAssigning(true);
                    setOpenUnassign(false);

                    axios
                      .put(API_HOST_CRM + "/ecd/unassign-pendings", {
                        caseIds: selectedRows.map((e) => e._id),
                        reason: unassignReason,
                      })
                      .then((resp) => {
                        if (resp.data && resp.data.success) {
                          getList(true);
                          setUnAssigning(false);
                          setUnassignCompleted(true);
                          setTimeout(() => {
                            setUnassignCompleted(false);
                          }, 2000);
                        }
                        setUnAssigning(false);
                      })
                      .catch((e) => {
                        console.log(e);
                        setUnAssigning(false);
                      });
                  },
                },
                {
                  name: "Cancel",
                  onClick: () => {
                    setOpenUnassign(false);
                  },
                },
              ]),
        ]}
      >
        <Typography sx={{ fontWeight: "bold" }}>
          Total selected cases: {selectedRows.length || 0}
        </Typography>
        <Box sx={{ mt: 2 }}>
          <SelectA
            field={{
              type: "select",
              label: "Unassign Reson",
              option: { key: "UnassignReasons", value: "_id", label: "name" },
              name: "unassignReason",
            }}
            data={{
              UnassignReasons,
            }}
            onChange={(name, value, multiple) => {
              setUnassignReason(value);
            }}
            value={unassignReason}
          />
        </Box>
      </Modal>
    </>
  );
};
